exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--2DTy3TICIXmZMhio_PCmeD {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1.25rem;\n}\n", ""]);

// exports
exports.locals = {
	"noteListContainer": "care-team-tasks--2DTy3TICIXmZMhio_PCmeD",
	"noteListContainer": "care-team-tasks--2DTy3TICIXmZMhio_PCmeD"
};